export const api = {  
  tagsEndPoint: 'https://college-backend-tyqu.onrender.com/tags/',
  usersEndPoint: 'https://college-backend-tyqu.onrender.com/users/',
  postsEndPoint: 'https://college-backend-tyqu.onrender.com/posts/',
  repliesEndPoint: 'https://college-backend-tyqu.onrender.com/reply/',
  otpEndPoint: 'https://college-backend-tyqu.onrender.com/otp/',
}
